const ZOOM_KEY = 'roadworld.minimapZoom.v1';
const NOTIFY_KEY = 'roadworld.areaNotifySettings.v1';

export function loadZoomIndex(defaultIdx: number, max: number): number {
  try {
    const raw = localStorage.getItem(ZOOM_KEY);
    if (raw === null) return defaultIdx;
    const n = Number(raw);
    if (!Number.isFinite(n)) return defaultIdx;
    return Math.max(0, Math.min(max, Math.round(n)));
  } catch {
    return defaultIdx;
  }
}

export function saveZoomIndex(idx: number): void {
  try {
    localStorage.setItem(ZOOM_KEY, String(idx));
  } catch {
    // localStorage unavailable — silently ignore so the game still works.
  }
}

/** Admin levels the player can opt to be notified about when crossing into a new region.
 *  Levels match OSM admin_level values; "country" and "state" come from the session-start
 *  Nominatim payload, not per-chunk boundaries. */
export type AreaTier = 'country' | 'state' | 'county' | 'city' | 'suburb' | 'neighbourhood';

export const AREA_TIERS: readonly AreaTier[] = [
  'neighbourhood',
  'suburb',
  'city',
  'county',
  'state',
  'country',
] as const;

export type AreaNotifySettings = Record<AreaTier, boolean>;

export const DEFAULT_NOTIFY_SETTINGS: AreaNotifySettings = {
  country: false,
  state: false,
  county: false,
  city: true,
  suburb: false,
  neighbourhood: true,
};

export function loadNotifySettings(): AreaNotifySettings {
  try {
    const raw = localStorage.getItem(NOTIFY_KEY);
    if (!raw) return { ...DEFAULT_NOTIFY_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<Record<AreaTier, unknown>>;
    const out: AreaNotifySettings = { ...DEFAULT_NOTIFY_SETTINGS };
    for (const tier of AREA_TIERS) {
      if (typeof parsed[tier] === 'boolean') out[tier] = parsed[tier] as boolean;
    }
    return out;
  } catch {
    return { ...DEFAULT_NOTIFY_SETTINGS };
  }
}

export function saveNotifySettings(s: AreaNotifySettings): void {
  try {
    localStorage.setItem(NOTIFY_KEY, JSON.stringify(s));
  } catch {
    // silently ignore
  }
}
